import React from 'react';
import { twMerge } from 'tailwind-merge';
import Tooltip from 'components/Core/Tooltip';
import { STIcon } from 'components/Brand/Icons/STIcon';

const PrefilledCheck = ({ title, className }) => {
  return (
    <Tooltip
      title={title}
      trigger={['click', 'hover']}
      className={twMerge('prefilledTooltip', className)}
      dataCy="prefilledCheckmarkContent"
      overlayClassName="prefilledOverlay"
      arrowPointAtCenter
      color="white"
    >
      <STIcon type="prefilledCheck" />
    </Tooltip>
  );
};

export default PrefilledCheck;
